import env from "./../env";

const Config = {
  apiUrl: env.baseUrl+'/api',
  apiBoUrl: env.baseUrl+'/bo-api',
}

export default Config